// extracted by mini-css-extract-plugin
export default {"btn":"ResidentsAssociationDetail_btn__yRsYO","wrapper":"ResidentsAssociationDetail_wrapper__Cpkji","toggleCheckbox":"ResidentsAssociationDetail_toggleCheckbox__HYt5I"};